import { useTranslation } from 'react-i18next';
import { Route } from 'lucide-react';

/** The amber « Zone secondaire » pill, shared by `CandidateCard` and `SolicitedTechnicians`. */
const SecondaryZonePill = () => {
  const { t } = useTranslation();
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-md bg-amber-100 px-1.5 py-0.5 text-[10.5px] font-semibold text-amber-800 dark:bg-amber-900 dark:text-amber-200">
      <Route className="h-3 w-3" aria-hidden="true" />
      {t('Secondary zone')}
    </span>
  );
};

export default SecondaryZonePill;
